export default __webpack_public_path__ + "static/media/7.49ebefe3.mp3";